import { Component, OnInit, OnDestroy } from "@angular/core";
import { UIService, UserService, BreakpointService } from "services";
import { Router } from "@angular/router";
import { Observable, Subscription } from "rxjs";
import { map } from "rxjs/operators";
import { User } from "models";

@Component({
    selector: "app-navbar-guest",
    template: require('./app-navbar-guest.component.html'),
    styles: [require('./app-navbar-guest.component.scss')],
    host: { class: "flex flex-shrink-0"},
})
export class AppNavbarGuestComponent implements OnInit, OnDestroy {
    private breakpointSubscription: Subscription;
    public searchString: string;
    private userSectionSubscription: Subscription;
    public switchedFromAdmin$: Observable<boolean>;
    public user: User = new User();

    shareUrl: string;
    navbarOpen = true;

    constructor(
        public userService: UserService,
        public router: Router,
        public uiService: UIService,
        private breakpointService: BreakpointService,
    ) { }

    ngOnInit(): void {
        // hiding mobile menu if breakpoint changed and mobile sidebar is open
        this.breakpointSubscription = this.breakpointService
            .isMoreThan("md")
            .subscribe((mobileState) => {
                if (mobileState === true)
                    this.navbarOpen = true;

            });

        // checking if user switchedFromAdmin
        this.switchedFromAdmin$ = this.userService.userToken$.pipe(
            map((userToken) => userToken.switchedFromAdmin || false)
        );
    }

    ngOnDestroy() {
        if (this.breakpointSubscription) this.breakpointSubscription.unsubscribe();
        if (this.userSectionSubscription)
            this.userSectionSubscription.unsubscribe();
    }

    toggleNavbar() {
        this.navbarOpen = !this.navbarOpen;
    }
}
